module.exports = __webpack_public_path__ + "img/bec9441.jpeg";